import cn from 'classnames';
import { ComponentProps, ReactElement, cloneElement, forwardRef } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import Skeleton from 'react-loading-skeleton';

// to be deprecated

interface PortalInputControllerProps extends ComponentProps<'input'> {
    name: string;
    label?: string;
    className?: string;
    children: ReactElement;
    asyncInput?: boolean;
    hasTooltipIcon?: boolean;
    toolTip?: ReactElement;
}

const PortalInputController = forwardRef<HTMLInputElement, PortalInputControllerProps>((props, ref) => {
    const { name, label, children, hasTooltipIcon = false, toolTip, asyncInput = false, ...rest } = props;
    const { required, disabled } = rest;
    const { control } = useFormContext();

    return (
        <Controller
            control={control}
            name={name}
            render={({
                field: { onChange, onBlur, value, name, ref },
                fieldState: { invalid, isTouched, isDirty, error },
                formState: { isSubmitted }
            }) => (
                <div>
                    <div className="flex flex-col gap-1 text-brand-text w-full">
                        {label ? (
                            <div className="flex items-center gap-1">
                                <label
                                    className={cn('relative text-xs text-brand-neutral-300', {
                                        'w-max': required
                                    })}>
                                    {label}
                                    {required && (
                                        <span className="absolute -top-1 -right-1.5 text-brand-secondary-light">*</span>
                                    )}
                                </label>
                                {hasTooltipIcon && toolTip ? toolTip : null}
                            </div>
                        ) : null}
                        <div className="w-full">
                            {asyncInput ? (
                                <Skeleton containerClassName="flex-1" />
                            ) : (
                                cloneElement(children, {
                                    ref,
                                    onChange,
                                    onBlur,
                                    label,
                                    name,
                                    value,
                                    selected: value,
                                    className: {
                                        'text-brand-neutral-400 cursor-not-allowed': disabled,
                                        '': !disabled
                                    },
                                    ...rest
                                })
                            )}
                        </div>
                    </div>
                    {error && (
                        <div className="flex justify-between items-center gap-3">
                            <div className="text-brand-red italic text-xs pt-1 w-full">{error?.message}</div>
                        </div>
                    )}
                </div>
            )}
        />
    );
});

PortalInputController.displayName = 'PortalInputController';

export default PortalInputController;
